module.exports = __webpack_public_path__ + "static/media/LogoCorreos2019_Azul.84eeca64.svg";